import io from "socket.io-client";

export default io("https://theril.herokuapp.com");
// export default io("http://localhost:3000");
